import { noun, verb } from 'plural-ru';
import Typograf from 'typograf';

export const typograf = new Typograf({ locale: ['ru', 'en-US'] });

typograf.enableRule('common/nbsp/afterNumber'); // Нераз. пробел между числом и словом

export const pluralPurchases = (count: number) =>
    noun(count, 'закупка', 'закупки', 'закупок');

export const pluralPlannedPurchases = (count: number) =>
    noun(
        count,
        'планируемая закупка',
        'планируемых закупки',
        'планируемых закупок'
    );

export const pluralFound = (count: number) =>
    verb(count, 'найдена', 'найдено', 'найдено');

export const integer = (value: number) => {
    return new Intl.NumberFormat('ru-RU', {
        style: 'decimal',
        maximumFractionDigits: 0,
    }).format(value);
};
